import { Injectable } from '@angular/core';
import { CanLoad, Route, UrlSegment, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AccessTokenGuard implements CanLoad {
  constructor ( public router: Router ) {}
  canLoad(
    route: Route,
    segments: UrlSegment[]): Observable<boolean> | Promise<boolean> | boolean {
    
    const login = JSON.parse(localStorage.getItem('login'));

    if ( login ) {
      return true;
    }else{
      this.router.navigate([""]);
      return false;
    }
  }
}
